import { Component, Input } from '@angular/core';
import { Domain } from '../../models/domain.model';
import { PositionType, positionTypeBadgeLabel } from '../../enums/position-type.enum';

/**
 * A row's identity badges — domain badges, then the L/S position badge — laid out as one
 * left-aligned, wrapping row. Built for the narrow TAGS column the Movers and Price Targets
 * tables show on phones, where the badges no longer fit beside the ticker. Anything projected
 * into it (e.g. a comparator flag) flows after the badges.
 */
@Component({
    selector: 'rms-row-tags',
    templateUrl: './row-tags.component.html',
    styleUrls: ['./row-tags.component.scss'],
    standalone: false
})
export class RowTagsComponent {
  @Input() domains: Array<Domain>;
  @Input() positionType: PositionType;

  public get positionTypeBadge(): string | null {
    return positionTypeBadgeLabel(this.positionType);
  }
}
